import { Component, input, output } from '@angular/core';
import { AppButtonComponent } from '@view/shared/molecules/button/button.component';
import { AppTranslationPipe } from '@adapter/i18n/app-translation.pipe';

@Component({
  selector: 'app-upload-template-card',
  imports: [AppButtonComponent, AppTranslationPipe],
  templateUrl: './upload-template-card.component.html',
  styleUrl: './upload-template-card.component.scss'
})
export class UploadTemplateCardComponent {
  isDisabled = input<boolean>(false);
  isOpaque = input<boolean>(false);
  isDownloading = input<boolean>(false);

  download = output<void>();
}
